

import store from '@/store'
import { sessionStore } from "@/utils/data-management";
// 初始化，排序表格对应index
export function tableFilter(data, must = false) {
  if (!data.columnList) {
    return
  }
  data.columnList.map(item => {
    // 分割 数量，单价，金额
    for (let i = 0; i < item.fieldList.length; i++) {
      if (item.fieldList[i].fieldName == "数量,单价,金额") {
        let data = item.fieldList[i],
          arr = [];
        for (let j = 0; j < 3; j++) {
          arr.push(JSON.parse(JSON.stringify(data)));
        }
        arr[0].fieldName = "数量";
        arr[1].fieldName = "单价";
        arr[2].fieldName = "金额";
        item.fieldList = item.fieldList
          .slice(0, i)
          .concat(arr)
          .concat(item.fieldList.slice(i + 1));
      }
    }
    // 栏目
    for (let i = 0; i < item.valueList.length; i++) {
      // 栏目数据
      let valueData = [];
      item.fieldList.map((list, index) => {
        for (let j = 0; j < item.valueList[i].valueData.length; j++) {
          // 行数据
          if (
            list.fieldId == item.valueList[i].valueData[j].fieldId
          ) {
            if (list.valueType == 2) {
              let val = [], id = item.valueList[i].valueData[j].fieldId;
              if (!item.valueList[i].valueData[j].value) {
                val = ['', '', '']
              } else {
                val = item.valueList[i].valueData[j].value.split(
                  ","
                )
              }
              if (list.fieldName == "数量") {
                valueData.push({ fieldId: id, value: val[0] });
              } else if (list.fieldName == "单价") {
                valueData.push({ fieldId: id, value: val[1] });
              } else {
                valueData.push({ fieldId: id, value: val[2] });
              }
            } else {
              valueData.push(item.valueList[i].valueData[j]);
            }
            return valueData;
          }
          // else {
          //   if (list.fieldName == "数量,单价,金额") {
          //     valueData.push({ fieldId: list.fieldId, value: "" });
          //     valueData.push({ fieldId: list.fieldId, value: "" });
          //     valueData.push({ fieldId: list.fieldId, value: "" });
          //   } else {
          //     valueData.push({ fieldId: list.fieldId, value: "" });
          //   }
          // }
        }
        if (valueData.length < index + 1) {
          valueData.push({ fieldId: list.fieldId, value: "" });
        }
      });
      item.valueList[i].valueData = valueData;
    }
  });

  // 贷款，保存农户id
  sessionStore.set('farmersInfoId', data.farmersInfoId)

  // sort 排序
  data.columnList.sort((a, b) => a.sort - b.sort)

  store.state.infoStatus = data.approvalStatus
  // 必填项是否填写完整
  if (must && data.approvalStatus == 3) {
    let complete = false;
    data.columnList.map(item => {
      if (complete) {
        return
      }
      // 非必填项过滤
      if (
        !item.isRequire &&
        item.valueList.length < 1
      ) {
        return;
      }
      // 必填项为空
      if (
        item.isRequire &&
        item.valueList.length < 1
      ) {
        complete = true;
        store.state.infoStatus = 0;
        return;
      }
      let ids = item.fieldList.map(list => {
        if (list.isRequire) {
          return list.fieldId;
        }
      });
      if (ids.length > 0) {
        item.valueList.map(list => {
          list.valueData.map(fieldId => {
            if (
              ids.indexOf(fieldId.fieldId) != -1 &&
              !fieldId.value
            ) {
              complete = true;
              store.state.infoStatus = 0;
            }
          });
        });
      }
    });
    if (!complete) {
      store.state.infoStatus = 3;
    }
  }
}
